export const featureCardThemes = {
  THE_ONE_CLUB: 'the_one_club',
};
